import {useRef,useMemo} from "react";
import WorkTimeEntryPopup from './WorkTimeEntryPopup.js';
import COMPONENT_MAP from '../Repository/Components.js';

//Time entries of one employee (My workday page and the user page "Working time" tab)
const WorkTimeEntries=({parentId,application,userData,refreshToken,height,file='WorkTimeEntries.js'})=>{
    const list_name='work_time_entries';
    const executeQuery=useRef(true);
    const renderListTab=useMemo(()=>{
        const Component=COMPONENT_MAP['ListTab'];
        return Component?(
            <Component
                parentId={parentId}
                application={application}
                userData={userData}
                entityType={'WorkTimeEntry'}
                entityParams={['system_user_id='+parentId,'_context='+['parent_name=SystemUser','parent_id='+parentId,'parent_field_value='+parentId],'_lang='+application.globalData.lang]}
                list_name={list_name}
                height={height}
                file={file}
                initialState={{}}
                navigateOnNew={null}
                checkboxSelection={true}
                disableRowSelectionOnClick={true}
                disableSelectionOnClick={true}
                popupComponent={WorkTimeEntryPopup}
                parentContext={{parent_field_name:'system_user_id',parent_field_value:null,parent_name:'SystemUser'}}
                executeQuery={executeQuery}
                refreshToken={refreshToken}
            />
        ):null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[parentId,application,userData,refreshToken]);

    return(renderListTab);
}

export default WorkTimeEntries;
